import React from 'react';
import PropTypes from 'prop-types';
import { formatDate, getTrimmedName } from '~/util';

const propTypes = {
    gap: PropTypes.shape({
        submission_answer: PropTypes.shape({
            metadata: PropTypes.shape({
                responses: PropTypes.arrayOf(
                    PropTypes.shape({
                        foc_action_detail: PropTypes.shape({
                            id: PropTypes.number,
                        }),
                        value: PropTypes.string,
                    })
                ),
            }),
        }),
        id: PropTypes.number.isRequired,
    }).isRequired,
    gapAction: PropTypes.shape({
        id: PropTypes.number,
        foc_action_details: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.number,
                lookup_metadata: PropTypes.arrayOf(
                    PropTypes.shape({
                        SupplementalDataValue: PropTypes.string,
                        SupplementalDataValueDescription: PropTypes.string,
                    })
                ),
                units: PropTypes.string,
            })
        ),
    }).isRequired,
};

export function FocSubmitRow({ gap, gapAction }) {
    let checked = false;
    const answers = {};
    gapAction.foc_action_details.forEach((detail) => {
        const answer = gap.submission_answer?.metadata?.responses.find(
            (x) => detail.id === parseInt(x.foc_action_detail?.id)
        );
        if (answer) {
            checked = true;
            answers[detail.id] = { value: answer.value };
            try {
                answers[detail.id].date = formatDate(answer.date);
            } catch (e) {
                answers[detail.id].date = null;
            }
        } else {
            answers[detail.id] = { date: null, value: '' };
        }
    });

    if (!checked) return null;

    return gapAction.foc_action_details.map((detail) => (
        <tr key={detail.id}>
            <td className="col-gap-action-name" colSpan="2" rowSpan="1">
                <label className="form-label ms-4">{getTrimmedName(detail.name)}</label>
            </td>
            <td className="w-20 text-center">
                <span>{answers[detail.id]?.date && answers[detail.id].date}</span>
            </td>
            <td className="w-35 text-center">
                {detail.lookup_metadata?.length ? (
                    detail.lookup_metadata.map(
                        (lookup) =>
                            answers[detail.id]?.value === lookup.SupplementalDataValue && (
                                <label
                                    className="form-label me-3"
                                    key={lookup.SupplementalDataValue}
                                >
                                    {lookup.SupplementalDataValueDescription}
                                </label>
                            )
                    )
                ) : (
                    <span>
                        {answers[detail.id]?.value}
                        &nbsp;
                        {detail.units}
                    </span>
                )}
            </td>
        </tr>
    ));
}

FocSubmitRow.propTypes = propTypes;
